var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"solo":""}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.chartTitle)+" ")]),_c('v-card-text',[_c('div',[_c('Bar',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions,"chart-id":_vm.chartId,"dataset-id-key":_vm.datasetIdKey,"plugins":_vm.plugins,"height":_vm.height}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }